"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnstyledButton = exports.IconButton = exports.default = exports.Button = void 0;

var React = _interopRequireWildcard(require("react"));

var _classify = _interopRequireDefault(require("../utils/classify"));

var _buttonModule = _interopRequireDefault(require("./button.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * our default Button class
 *
 * We use a div because `<button>` has a lot of style quirks that differ
 * between browsers
 *
 * Note that onClick does NOT take a MouseEvent and instead just a regular Event.
 * This is because the keyup event can trigger the click event, and we'd rather
 * not use the `.click()` method.
 */
const Button = /*#__PURE__*/React.forwardRef(({
  type = 'default',
  size = 'large',
  multi,
  round,
  icon,
  disabled,
  styleDisabled,
  className,
  children,
  withMinWidth,
  color,
  // $FlowFixMe
  style,
  ...props
}, ref) => /*#__PURE__*/React.createElement(UnstyledButton, _extends({}, props, {
  className: (0, _classify.default)(className, _buttonModule.default.buttonText, _buttonModule.default[type], _buttonModule.default[size], {
    [_buttonModule.default.buttonIcon]: icon,
    [_buttonModule.default.buttonEnabled]: !disabled,
    [_buttonModule.default.buttonDisabled]: styleDisabled !== null && styleDisabled !== void 0 ? styleDisabled : disabled,
    [_buttonModule.default.buttonRound]: round,
    [_buttonModule.default.multi]: multi,
    [_buttonModule.default.withMinWidth]: withMinWidth
  }),
  disabled: disabled,
  ref: ref,
  style: { ...style,
    ...(color && !disabled ? type === 'primary' ? {
      backgroundColor: color
    } : {
      color
    } : null)
  }
}), icon && /*#__PURE__*/React.createElement("div", {
  className: _buttonModule.default.icon
}, icon), /*#__PURE__*/React.createElement("span", {
  className: _buttonModule.default.children
}, children)));
exports.Button = Button;
var _default = Button;
exports.default = _default;
const IconButton = /*#__PURE__*/React.forwardRef(({
  type = 'default',
  size = 'small',
  round,
  disabled,
  styleDisabled,
  className,
  ...props
}, ref) => /*#__PURE__*/React.createElement(UnstyledButton, _extends({}, props, {
  className: (0, _classify.default)(className, _buttonModule.default.iconButton, _buttonModule.default[type], _buttonModule.default[size], {
    [_buttonModule.default.buttonEnabled]: !disabled,
    [_buttonModule.default.buttonDisabled]: styleDisabled !== null && styleDisabled !== void 0 ? styleDisabled : disabled,
    [_buttonModule.default.buttonRound]: round
  }),
  ref: ref
})));
exports.IconButton = IconButton;
const UnstyledButton = /*#__PURE__*/React.forwardRef(({
  disabled,
  onKeyPress,
  onClick,
  className,
  ...props
}, ref) => /*#__PURE__*/React.createElement("div", _extends({}, props, {
  className: className,
  ref: ref,
  role: "button",
  disabled: disabled,
  tabIndex: !disabled ? '0' : null,
  onKeyPress: event => {
    if (disabled) {
      event.preventDefault();
    } else {
      if (onKeyPress) {
        onKeyPress(event);
      }

      if (onClick && !event.isDefaultPrevented() && (event.key === 'Enter' || event.key === 'Space')) {
        onClick(event);
      }
    }
  },
  onClick: event => {
    if (disabled) {
      event.preventDefault();
    } else if (onClick) {
      onClick(event);
    }
  }
})));
exports.UnstyledButton = UnstyledButton;